// Utilities extracted from ChatContainerModule.js

import _ from "lodash";
import update from "immutability-helper";
import client from "lib/apolloClient/client";
import { getConversationsQuery } from "AppComponents/ChatContainer/modules/ChatContainerQuery";
import { generateRandomId, getTaggedUserIds } from "Utils";
import {
  writeMessageFragment,
  readMessageFragment,
} from "modules/CommonGraphqlHelpers";
import { updateMessageMutation } from "modules/CommonMutations";
import { INTIAL_RECORDS_NUMBER } from "./ChatContainerConstants";

const EXCLUDE_ITEM_TYPES_FOR_CONVERSATION_READ = [
  "STUDENT_ASSIGNMENT_SUBMISSION_FEEDBACK",
];

const STAFF_BASIC_DETAILS_PICK_KEYS = [
  "id",
  "firstName",
  "middleName",
  "lastName",
  "email",
  "profileImage",
  "__typename",
];

const STUDENT_BASIC_DETAILS_PICK_KEYS = [
  "id",
  "firstName",
  "middleName",
  "lastName",
  "email",
  "profileImage",
  "preferredName",
  "suffix",
  "pronouns",
  "__typename",
];

export const getChatQueryVariables = ({
  id,
  showAllMessages,
  endCursor,
  showInstructionMessage,
  extraFilters = null,
}) => {
  const chatQueryVars = {
    id,
    filters: {
      showInstructionMessage,
    },
  };
  if (!showAllMessages) chatQueryVars["first"] = INTIAL_RECORDS_NUMBER;
  if (endCursor) chatQueryVars["after"] = endCursor;
  if (extraFilters) {
    chatQueryVars.filters = { ...chatQueryVars.filters, ...extraFilters };
  }
  return chatQueryVars;
};

export const updateMessage = params => {
  const mainMessage = readMessageFragment({ id: params.id });
  const conversationId = _.get(params, "conversationId", "");
  const showAllMessages = _.get(params, "showAllMessages", false);
  const showInstructionMessage = _.get(params, "showInstructionMessage", true);
  const extraFilters = _.get(params, "extraFilters", {});
  const isPinToggle = _.get(params, "isPinToggle", false);

  const chatQueryVariables = getChatQueryVariables({
    id: conversationId,
    showAllMessages,
    showInstructionMessage,
    extraFilters,
  });

  let refetchQuery = {};

  if (isPinToggle) {
    refetchQuery = {
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: getConversationsQuery,
          variables: chatQueryVariables,
        },
      ],
    };
  }

  const attachments = _.map(params.attachments, attachment => {
    return {
      id: generateRandomId(),
      ...attachment,
      __typename: "Attachment",
    };
  });

  const taggedUsers = _.isEmpty(params.collaborators)
    ? []
    : getTaggedUserIds({
        comment: params.label,
        collaborators: params.collaborators,
      });

  if (!_.isEmpty(taggedUsers)) {
    params["taggedUsers"] = taggedUsers;
  }

  const updatedData = update(mainMessage, {
    type: { $set: params.type },
    isPin: { $set: params.isPin },
    label: { $set: params.label },
    item: {
      $apply: item => {
        if (_.isNull(item)) {
          return { attachments };
        } else {
          return { ...item, attachments };
        }
      },
    },
  });

  const filteredParams = _.omit(params, ["collaborators"]);

  writeMessageFragment({
    nodeId: params.id,
    data: updatedData,
  });

  return async () => {
    try {
      const response = await client.mutate({
        mutation: updateMessageMutation,
        variables: { ...filteredParams },
        ...refetchQuery,
        // variables: { ...params },
      });
      return { ...response, successful: true };
    } catch (e) {
      setTimeout(() => {
        writeMessageFragment({
          nodeId: params.id,
          data: mainMessage,
        });
      });
      if (e.networkError) {
        return {
          successful: false,
          errors: ["toastMsgs:no_internet_connection"],
        };
      } else {
        return {
          successful: false,
          errors: ["toastMsgs:something_went_wrong"],
        };
      }
    }
  };
};

export const getChatConversation = params => {
  return async () => {
    const result = await client.query({
      query: getConversationsQuery,
      variables: getChatQueryVariables(params),
      fetchPolicy: "network-only",
    });

    return _.get(result, "data.node", []);
  };
};

// Auto-generated exports
export {
  EXCLUDE_ITEM_TYPES_FOR_CONVERSATION_READ,
  STAFF_BASIC_DETAILS_PICK_KEYS,
  STUDENT_BASIC_DETAILS_PICK_KEYS,
};
